<template>
  <section class="bg-static-info-mid relative py-28">
    <div class="relative mx-auto max-w-full px-24 md:max-w-[900px] md:px-32">
      <h1 class="heading-1">
        {{ i18n(translations.title) }}
      </h1>

      <RevInputText
        id="help-center-search"
        v-model="search"
        class="mt-12"
        :icon="IconSearch"
        :label="i18n(translations.searchLabel)"
        type="search"
      />

      <ErrorContainer
        v-if="categoriesError"
        class="mt-24"
        data-qa="help-home-faq-categories-error"
        @retry="refreshCategories"
      />
      <FAQCategories v-else-if="categories?.length" class="mt-24" :categories />
    </div>
  </section>
</template>

<script setup lang="ts">
import { useAsyncData } from '#imports'
import { ref } from 'vue'

import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevInputText } from '@ds/components/InputText'
import { IconSearch } from '@ds/icons/IconSearch'

import ErrorContainer from '@/scopes/care-commons/components/ErrorContainer/ErrorContainer.vue'
import { SALES_CUSTOMER_CARE_SCOPE } from '~/scopes/care-commons/utils/logger/salesCustomerCare/config'
import { useSalesCustomerCareLogger } from '~/scopes/care-commons/utils/logger/salesCustomerCare/useSalesCustomerCareLogger'

import translations from './FAQSection.translations'
import FAQCategories from './components/FAQCategories/FAQCategories.vue'

const i18n = useI18n()
const search = ref('')
const $httpFetch = useHttpFetch()
const { logHttpError } = useSalesCustomerCareLogger()

const {
  data: categories,
  error: categoriesError,
  refresh: refreshCategories,
} = useAsyncData(async () => {
  return $httpFetch('/help-center/api/v1/categories', {
    onResponseError: ({ response }) => {
      if (response) {
        logHttpError({
          // eslint-disable-next-line no-underscore-dangle
          error: response._data,
          errorStatusCode: response.status,
          errorTitle: `${SALES_CUSTOMER_CARE_SCOPE.helpCenter} Error when fetching FAQ categories`,
        })
      }
    },
  })
})
</script>
